module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_8019.e79b93eb.png";